module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_8023.bd34b749.png";